export const validatedStops = items =>
  items
    .filter(item => item.depot && item.address)
    .map(item => ({
      depot: item.depot,
      address: item.address,
    }));
